// The box, the five columns and the eye.
const COLUMN_COUNT = 7;

/**
 * Grey pulsing rows standing for the invoices of an unfolded row while they
 * are read. The borders are on the cells: dashed ones on `tr` do not render
 * in a collapsed-border table. The last row has the solid one that closes the
 * unfolded row.
 */
const InvoiceSkeletonRows = ({ count, label }) =>
  Array.from({ length: count }, (_, row) => {
    const border =
      row === count - 1
        ? 'border-b border-gray-100'
        : 'border-b border-dashed border-gray-200';
    return (
      <tr key={row} aria-busy="true">
        {Array.from({ length: COLUMN_COUNT }, (__, column) => (
          <td
            key={column}
            className={`${border} ${column === 0 ? 'py-5 pl-4 pr-2' : 'px-2 py-5'}`}
          >
            {column > 0 && column < COLUMN_COUNT - 1 && (
              <div className="h-2 skeleton-bar" />
            )}
            {row === 0 && column === 0 && (
              <span role="status" className="sr-only">
                {label}
              </span>
            )}
          </td>
        ))}
      </tr>
    );
  });

export default InvoiceSkeletonRows;
